import * as React from "react";
import { ScrollContainer } from "react-ui";

import { UnitId, unitIdToLegacyUnitId } from "../Unit/UnitId/UnitId";
import { emptyRef } from "../../TypingUtils";
import { useTestPageObject } from "../../Services/TestPageObjects/PageObjectExposure";
import { DomElementsRegistry, ScrollToContextHandle } from "../../Commons/DOM/DomElementsRegistry";

import { UnitListRoot } from "./UnitList.styles";
import { UnitListTestPageObject } from "./UnitListTestPageObject";

export interface UnitListProps {
    children: React.ReactNode;
    currentUnit?: UnitId | undefined;
}

export function UnitList(props: UnitListProps): JSX.Element {
    const { currentUnit } = props;
    const currentUnitLegacyId = React.useMemo(() => unitIdToLegacyUnitId(currentUnit), [currentUnit]);
    const domElementsRegistry = React.useRef<ScrollToContextHandle>(emptyRef);
    const scrollContainer = React.useRef<HTMLUListElement>(emptyRef);

    useTestPageObject(() => UnitListTestPageObject(currentUnitLegacyId), [currentUnitLegacyId]);

    React.useEffect(() => {
        const currentUnitElement = domElementsRegistry.current?.getDomElementById(currentUnitLegacyId);
        if (
            scrollContainer.current != undefined &&
            scrollContainer.current.parentElement != undefined &&
            currentUnitElement != undefined
        ) {
            scrollToNode(scrollContainer.current.parentElement, currentUnitElement);
        }
    }, [currentUnitLegacyId]);

    return (
        <DomElementsRegistry ref={domElementsRegistry}>
            <ScrollContainer showScrollBar="scroll">
                <UnitListRoot ref={scrollContainer}>{props.children}</UnitListRoot>
            </ScrollContainer>
        </DomElementsRegistry>
    );
}

function scrollToNode(scrollableParent: HTMLElement, targetElement: HTMLElement): void {
    const targetElementRect = targetElement.getBoundingClientRect();
    const scrollableParentRect = scrollableParent.getBoundingClientRect();

    if (targetElementRect.bottom > scrollableParentRect.bottom) {
        scrollableParent.scrollTop += targetElementRect.bottom - scrollableParentRect.bottom;
    } else if (targetElementRect.top < scrollableParentRect.top) {
        scrollableParent.scrollTop -= scrollableParentRect.top - targetElementRect.top;
    }
}
